import React from "react";
import { getText } from "../../data/content";
import { theme, combineClasses } from "../../theme/theme";
import { FooterLogos } from "../Logos";

/**
 * ============================================================================
 * ############## AppFooter：页脚区（Home 专用） ################################
 * ============================================================================
 *
 * 【作用】（第三人称客观注释）
 * - 仅在首页展示：版权信息 +（可选）社交链接 + 合作/机构 Logo。
 * - 将页脚从 App.tsx 中抽离，降低顶层文件长度并提升可维护性。
 */
export interface AppFooterProps {
  lang: "en" | "cn";
  themeMode: "light" | "dark";
}

const AppFooter: React.FC<AppFooterProps> = ({ lang, themeMode }) => {
  const isLight = themeMode === "light";

  return (
    <>
      <footer
        className={combineClasses(
          `w-full border-t py-4 mt-auto ${
            isLight ? "border-gray-200 " + theme.backgrounds.glassLight : "border-white/10 " + theme.backgrounds.glass
          }`
        )}
      >
        <div className={`max-w-4xl mx-auto px-4 text-center text-sm ${isLight ? "text-gray-600" : "text-gray-500"}`}>
          <p>{getText("footer.rights", lang)}</p>

          {/* 页脚的社交媒体链接，目前不显示 */}
          {/*
          <div className="flex justify-center space-x-6 mt-3">
            ...
          </div>
          */}
        </div>
      </footer>

      {/* 系和国家实验室Logo - 页脚下方 */}
      <div className={`w-full border-t py-4 ${isLight ? "border-gray-200 bg-white/60" : "border-white/10 bg-black/60"}`}>
        <FooterLogos />
      </div>
    </>
  );
};

export default AppFooter;
